import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ImagesWitRadio } from "../../../../Constant";
import { IMAGE_WITH_RADIO } from "../../../../Data/FormControl/CheckboxAndRadio";
import CustomImagesWithRadio from "./CustomImagesWithRadio";
import DynamicImagesWithRadio from "./DynamicImagesWithRadio";

const ImagesWithRadio = () => {
    return (
        <Col sm="12">
          <Card>
            <CommonCardHeader title={ImagesWitRadio} span={IMAGE_WITH_RADIO} />
            <CardBody>
              <div className="main-img-checkbox">
                <Row className="g-3">
                  <CustomImagesWithRadio />
                  <DynamicImagesWithRadio />
                </Row>
              </div>
            </CardBody>
          </Card>
        </Col>
      );
}

export default ImagesWithRadio